import { render } from "./Deduction_Details.vue?vue&type=template&id=1432dcf4&scoped=true"
import script from "./Deduction_Details.vue?vue&type=script&lang=js"
export * from "./Deduction_Details.vue?vue&type=script&lang=js"

import "./Deduction_Details.vue?vue&type=style&index=0&id=1432dcf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1432dcf4"]])

export default __exports__